export class PanelMenuComponent {
  private panelMenuLevelItems: HTMLElement[]; // data-panel-menu-level

  constructor(
    private container: HTMLElement
  ) {
    this.panelMenuLevelItems = Array.prototype.slice.call(this.container.querySelectorAll('[data-panel-menu-level]'));
  }
  public initialize(): void {
    const safePath = window.location.pathname.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
    const currentPath = decodeURI(safePath);
    this.panelMenuLevelItems.forEach((panelMenuLevelItem: HTMLElement ) => {
      if (panelMenuLevelItem.getAttribute('href') === currentPath) {
        panelMenuLevelItem.classList.add('active');
      }
      panelMenuLevelItem.querySelectorAll('ul').forEach((ul: HTMLElement) => {
        ul.querySelectorAll('li').forEach((li: HTMLElement) => {
          if (li.querySelector('a')?.getAttribute('href') === currentPath) {
            li.querySelector('a')?.classList.add('active')
            const p: HTMLParagraphElement | null | undefined
              = li?.closest('[data-panel-menu-level]')?.querySelector('p');
            if (p) {
              p.classList.add('active');
            }
          }
        });
      });
      panelMenuLevelItem.querySelectorAll('a').forEach((itemA: HTMLElement) => {
        if (itemA.getAttribute('href') === currentPath) {
          itemA.classList.add('active');
          const h3: HTMLParagraphElement | null | undefined
              = itemA?.closest('[data-panel-menu-level]')?.querySelector('h3');
          if (h3) {
            h3.classList.add('active');
          }
        }
      });
    });
  }
}
